<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <a v-go-back="'partner_categories'">Categorias Parceiros</a>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <a
                class="section"
                :href="$router.resolve({ name: 'newPartnerCategory' }).href"
              >
                <i class="plus icon"></i>Nova Categoria
              </a>
              <a @click.prevent="openHistory"
                ><i class="history icon"></i>Histórico</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal
        ref="history"
        resource="PartnerCategory"
        :item_id="form.id"
      />
      <form
        :class="['ui small', { error: anyError }, 'form']"
        @submit.prevent="save"
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div
                :class="['required', { error: errors.description }, 'field']"
                :data-content="errorsTo('description')"
              >
                <label for="partner-category-form-description">Descrição</label>
                <input
                  type="text"
                  autofocus
                  id="partner-category-form-description"
                  name="name"
                  v-model="form.description"
                />
              </div>
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove"
                  ><i class="trash icon"></i>Remover Categoria</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';

export default {
  components: { Breadcrumb, PageLayout, HistoryModal },

  data() {
    return {
      loading: false,
      loadingCep: false,
      errors: {},
      form: {
        id: null,
        description: null
      }
    };
  },

  computed: {
    persisted() {
      return this.form.id != null;
    },

    sectionName() {
      return this.persisted
        ? `Editar Categoria - ${this.form.id}`
        : 'Novo Categoria';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.$route.params.id) {
        this.fetch(this.$route.params.id);
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors);
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    openHistory() {
      this.$refs.history.open();
    },

    save() {
      this.loading = true;
      this._setErrors({});

      Api.partnerCategories
        .save(this.form)
        .then(async response => {
          this.$toast.show('Categoria salva com sucesso', 'success');
          this.form = _.clone(response.data.partner_category);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar serviço', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Categoria?');
      if (removeIt) {
        this.loading = true;
        Api.partnerCategories
          .destroy(this.form.id)
          .then(async response => {
            this.$toast.show('Categoria removido com sucesso', 'success');
            this.$router.push({ name: 'partner_categories' });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover categoria', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    fetch(id) {
      this.loading = true;
      Api.partnerCategories
        .fetch(id)
        .then(async response => {
          this.form = _.clone(response.data.partner_category);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar serviço', 'error');
            this.$router.push({ name: 'partner_categories' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>
